import React, { useState } from "react";
import AnttButton from "../../../vendors/components/Button";
import { faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import "./assets/index.scss";
import If from "../../../vendors/components/If";
import InnerHtml from "../inner-html";

interface Props {
  value: any;
  eventoAberto: any;
  evento: any;
  handleClick: any;
  isView?: any;
  index?: number;
  hideButton?: any;
}

export default function ContribuicaoItem({
  value,
  eventoAberto,
  evento,
  handleClick,
  isView,
  hideButton,
  index = 0,
}: Props) {

  return (
    <div className={`w-full flex items-center justify-between px-5 py-4 border-b border-gray-100 ${index % 2 === 0 ? "bg-white" : "bg-gray-50"} hover:bg-gray-100 transition-colors duration-200 group`}>
      <div className="flex-1 pr-4">
        <If condition={value.dsDispositivo.length > 25}>
          <div
            className="cursor-pointer flex items-baseline gap-2"
            title="Clique para expandir/retrair"
          >
            <div className={`text-sm text-gray-600 line-clamp-1 transition-all`}>
              <InnerHtml value={value.dsDispositivo} />
            </div>
          </div>
        </If>
        <If condition={value.dsDispositivo.length <= 25}>
          <div className="flex items-baseline gap-2">
            <div className="text-sm text-gray-600">
              <InnerHtml value={value.dsDispositivo} />
            </div>
          </div>
        </If>
      </div>
      <If condition={value.dsDispositivo != "ContribuicaoOutrosMeios"}>
        <AnttButton
          style={{
            visibility:
              value.stPermiteContribuicao && eventoAberto && !hideButton
                ? "visible"
                : "hidden",
          }}
          onClick={() => {
            handleClick();
          }}
          faIcon={isView ? faEye : faPencil}
          className="p-button-rounded p-button-text p-button-sm opacity-70 group-hover:opacity-100 transition-opacity"
          tooltip={isView ? "Visualizar" : "Contribuir"}
          tooltipOptions={{ position: "top" }}
        />
      </If>
    </div>
  );
}
